export default __webpack_public_path__ + "static/media/statsup-blue.237fbbc4.svg";